const checkStrategyAnalystApprovalStatus = (initiative) => {
    if (initiative && initiative.request && initiative.request.requestedStage) {
      const stage = initiative.stage;
      const requestedStage = initiative.request.requestedStage;
      let approvalStageKey = null;
  
      if (initiative.hasFinancialImpact === false) {
        if ((stage === 'L1' || stage === 'L2') && requestedStage === 'Submitted for L2 Approval') {
          approvalStageKey = 'L2';
        } else if ((stage === 'L2' || stage === 'L3') && requestedStage === 'Submitted for L3 Approval') {
          approvalStageKey = 'L3';
        } else if ((stage === 'L3' || stage === 'L4') && requestedStage === 'Submitted for L4 Approval') {
          approvalStageKey = 'L4';
        } else if ((stage === 'L4' || stage === 'L5') && requestedStage === 'Submitted for L5 Approval') {
          approvalStageKey = 'L5';
        } else {
          return 'Not Set';
        }
  
        if (initiative.approvalSummary && initiative.approvalSummary[approvalStageKey]) {
          const approvers = initiative.approvalSummary[approvalStageKey].approvers || [];
          if (approvers.length === 2) {
            return 'Pending';
          } else if (approvers.length === 3) {
            return 'Approved';
          }
        } else {
          return 'Not Set';
        }
      } else {
        if ((stage === 'L0' || stage === 'L1') && requestedStage === 'Submitted for L1 Approval') {
          approvalStageKey = 'L1';
        }
  
        if (approvalStageKey && initiative.approvalSummary && initiative.approvalSummary[approvalStageKey]) {
          const approvers = initiative.approvalSummary[approvalStageKey].approvers || [];
          if (approvers.length === 1) {
            return 'Pending';
          } else if (approvers.length === 3) {
            return 'Approved';
          }
        } else {
          return 'Not Set';
        }
      }
    }
    return 'Not Set';
  };
  
  export default checkStrategyAnalystApprovalStatus;